import classNames from "classnames";
import { useLocation } from "react-router";
import styles from "./JobDetail.module.scss";
import { Link } from "react-router-dom";
import filterImg from "../../Img/jobPage/filter.png";
import { list } from "../../common/jobList/jobList.js";
import { ReactComponent as LeftIcon } from "monoff-web-design-system/src/img/icon/24/Brackets, Type=Left, Wide=False.svg";
import { useEffect } from "react";

export default function JobDetail({
  isDarkMode,
  width,
}: {
  isDarkMode: boolean;
  width: number;
}) {
  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);
  const location = useLocation();
  let job: Job = list.find(
    (data) => Number(location.pathname.split("/")[2]) === data.id
  ) as Job;
  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <section className={styles.duty_container}>
          <div className={styles.duty}>
            <p
              className={classNames({
                "title-kr-L": width > 767 ? true : false,
                "label-kr-L": width < 768 ? true : false,
              })}
            >
              {job?.team}
            </p>
            <p
              className={classNames({
                "display-kr-L": width > 767 ? true : false,
                "title-kr-XL": width < 768 ? true : false,
              })}
            >
              {job?.duty}
            </p>
          </div>
        </section>

        <div className={styles.topBackground}>
          <img
            src={job.img}
            alt=""
            className={
              job.position === "개발" ? styles.selectImg : styles.defaultImg
            }
          />
          <img
            src={filterImg}
            alt=""
            className={
              job.position === "개발" ? styles.selectImg : styles.defaultImg
            }
          />
        </div>
      </div>

      <section className={styles.contents_container}>
        <div
          className={classNames(
            !isDarkMode ? styles.contextContainer : styles.dark_contextContainer
          )}
        >
          <section className={styles.detail_info_768}>
            <div className={styles.detail_info_item_768}>
              <p className={classNames({ "title-kr-M": true })}>직군</p>
              <p className={classNames({ "body-kr-M": true })}>{job.duty}</p>
            </div>
            <div className={styles.detail_info_item_768}>
              <p className={classNames({ "title-kr-M": true })}>경력사항</p>
              <p className={classNames({ "body-kr-M": true })}>
                {job.type.split("•")[1]}
              </p>
            </div>
            <div className={styles.detail_info_item_768}>
              <p className={classNames({ "title-kr-M": true })}>고용형태</p>
              <p className={classNames({ "body-kr-M": true })}>
                {job.type.split("•")[0]}
              </p>
            </div>
            <div className={styles.detail_info_item_768}>
              <p className={classNames({ "title-kr-M": true })}>마감기한</p>
              <p className={classNames({ "body-kr-M": true })}>-</p>
            </div>
          </section>
          <section className={styles.explan_text}>
            {job?.position === "경영지원" && job?.sort === "HR" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    mondayoff HR팀은{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    회사의 비전과 조직 문화에 맞는 인재를 채용하고, 인사 제도의
                    기획 및 운영을 통해 회사의 성장을 전폭적으로 서포트하는
                    팀입니다. mondayoff는 2018년에 설립하여, 급속도로 성장하고
                    있는 모바일 게임 개발/퍼블리싱 스타트업 입니다. HR팀은
                    앞으로 더 큰 폭의 성장을 위해 회사의 필요한 인력풀을
                    캐치하여 채용하고, 신규 입사자의 빠른 적응을 위해 맞춤형
                    온보딩 프로그램을 진행합니다. 또한 인재가 조직에서 최고의
                    역량을 발휘할 수 있도록 조직 문화 및 인사 체계를 만들어 갈
                    분들을 기다리고 있습니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
            {job?.position === "경영지원" && job?.sort === "Money" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    mondayoff 경영지원팀은{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    회사가 더욱 안정적으로 성장할 수 있도록 경영 업무들을
                    지원해주는 팀입니다. mondayoff는 2018년에 설립하여, 급속도로
                    성장하고 있는 모바일 게임 개발/퍼블리싱 스타트업 입니다.
                    회사의 운용 자금이 점점 커지고 있는 환경에서, 경영지원팀의
                    회계부서에서는 투명한 장부관리와 분기별 부가세 신고, 기말
                    회계감사 지원 등 회사의 전반적인 회계 업무를 진행합니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
            {job?.position === "개발" && job?.sort === "Game" ? (
              <>
                <div className={styles.game_explain_box}>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    Everyone, mondayoff{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 “가장 힘든 월요일조차 우리의 게임과 함께라면
                    즐거워질 수 있다”는 마음에서 시작했습니다. 국가, 문화, 성별,
                    나이를 초월해 전 세계 유저들에게 최고의 즐거움을 선사하기
                    위해 늘 고민하고 도전합니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 직군의 경계를 두지 않습니다. 누구나 진행 중인
                    프로젝트에 자유롭게 의견을 제시하고, 다양한 시각을 모아 함께
                    더 재미있는 게임을 만들어 갑니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 한국 시장만 집중하지 않습니다. 창립 이래 하이퍼
                    캐주얼 게임 장르로 사업을 시작하면서 쌓아온 글로벌 시장
                    경험을 바탕으로 전 세계 플레이어와 소통하며 성장하고
                    있습니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 언제나 데이터를 기반으로 연구하고, 토론하고,
                    실험하며 발전하는 팀입니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    귀하의 새로운 도전을 응원하며, 저희와 함께 더 큰 시장에
                    도전하고 싶으신 분들의 지원을 기다리고 있습니다.
                  </p>
                </div>
                {/* <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    Hyper-Casual?
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    하이퍼 캐주얼은 언어, 문화, 성별 및 나이에 상관없이 누구나
                    쉽게 즐길 수 있는 게임입니다. 복잡한 룰이나 UX는 최대한
                    배제하고, 간단하게 게임을 구성하는 것이 중요합니다. 언뜻
                    보면 다소 시시하다고 느낄 수 있지만, 유저의 데이터를
                    기반으로 R{"&"}D가 많이 필요한 장르입니다.
                  </p>
                  <br />
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    국내 시장에선 RPG, Defence 장르의 규모가 큰 게임들이 차트의
                    상위권을 이루고 있지만, 글로벌 차트는 그렇지 않습니다. 미국
                    iOS 인기차트의 경우 50위 권 안에 70% 이상이 하이퍼 캐주얼
                    게임이고, 앞으로 하이퍼 캐주얼 게임 시장의 규모는 더욱 더
                    확대될 것으로 보입니다.
                  </p>
                  <br />
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    하이퍼 캐주얼 스튜디오팀은 R{"&"}D를 멈추지 않습니다. ‘이
                    부분에서 어떤 이펙트가 연출되어야 유저의 심리에 가장
                    긍정적인 영향을 줄 수 있을까?’, ‘이 게임의 UX가 플레이를
                    하는 유저들에게 어렵진 않을까?’, ‘특정 스테이지의 이탈률이
                    급격하게 늘어나는 이유는 무엇일까?’ 등 게임 제작에서 멈추지
                    않고 많은 고민들을 해결하며 점점 더 넓은 유저층을
                    확보합니다.
                  </p>
                  <br />
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    먼데이오프에서는 다소 생소할 수 있는 하이퍼 캐주얼 게임
                    장르에 대해 지속적으로 고민하고, 함께 연구하면서 성장하고
                    싶은 분들의 지원을 기다리고 있습니다.
                  </p>
                </div> */}
              </>
            ) : (
              ""
            )}
            {job?.position === "개발" && job?.sort === "Server" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    mondayoff 퍼블리싱 대시보드 개발팀은{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    해외 게임 스튜디오팀과의 연결창구를 마련하는 팀입니다.
                    우리는 각 국에 위치한 게임 스튜디오팀과 긴밀한 파트너십을
                    맺고 교류하며 글로벌 퍼블리싱 사업을 진행하고 있습니다.
                    대시보드 개발 팀에서는 파트너사와의 원활한 협업을 위해
                    대시보드를 개발하고 유지, 보수합니다. 트래킹 툴이나 광고
                    매체에서 제공하는 API를 기반으로 게임 별 데이터를 수집하고
                    가공하여 대시보드를 통해 파트너사에게 보다 좋은 협업 방향을
                    제시합니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
            {job?.position === "디자인" && job?.sort === "Game" ? (
              <>
                <div className={styles.game_explain_box}>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    Everyone, mondayoff{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 “가장 힘든 월요일조차 우리의 게임과 함께라면
                    즐거워질 수 있다”는 마음에서 시작했습니다. 국가, 문화, 성별,
                    나이를 초월해 전 세계 유저들에게 최고의 즐거움을 선사하기
                    위해 늘 고민하고 도전합니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 직군의 경계를 두지 않습니다. 누구나 진행 중인
                    프로젝트에 자유롭게 의견을 제시하고, 다양한 시각을 모아 함께
                    더 재미있는 게임을 만들어 갑니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 한국 시장만 집중하지 않습니다. 창립 이래 하이퍼
                    캐주얼 게임 장르로 사업을 시작하면서 쌓아온 글로벌 시장
                    경험을 바탕으로 전 세계 플레이어와 소통하며 성장하고
                    있습니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff는 언제나 데이터를 기반으로 연구하고, 토론하고,
                    실험하며 발전하는 팀입니다.
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    귀하의 새로운 도전을 응원하며, 저희와 함께 더 큰 시장에
                    도전하고 싶으신 분들의 지원을 기다리고 있습니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
            {job?.position === "사업/마케팅" &&
            job?.sort === "Publishing" &&
            job?.lo === "en" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    mondayoff, Hypercasual Lead in East Asia{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff is East Asia’s leading studio and publisher in the
                    field of the mobile game genre Hyper Casual. With tons of
                    experience developing in-house games and publishing games
                    with our partners from around the world, we strive to become
                    one of the top global mobile game publishers. Since our
                    foundation in 2018, we’ve grown to become a team of over 25
                    developers, designers and publishing managers. We are
                    looking for new talent to bring out the most creative games
                    in the market that are fun and keep players engaged for a
                    long time.
                  </p>
                </div>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    What are hypercasual games?
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    Hypercasual games are enjoyed by players worldwide, no
                    matter their language, cultural background, age or gender.
                    Simple rules and design that can be understood within 3
                    seconds make hypercasual games different from other mobile
                    games on the market.
                  </p>
                  <br />
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    Korea’s leading mobile game genres tend to be RPG and
                    defense, differing strongly from the international market.
                    Over 70% of the US iOS Game Top 50 are hypercasual games and
                    numbers are rising steadily.
                  </p>
                  <br />
                  <p>
                    Studios developing hypercasual games have to go beyond
                    simple R{"&"}D. “What effect will bring the most
                    satisfaction to the player at this instance?” “Is the UX too
                    complicated for the players?” “Why do players quit playing
                    at certain stages of the game?” are questions we constantly
                    have to answer in order to reach a wide audience.
                  </p>
                  <br />
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    At MondayOFF, we are looking for creative people that will
                    try to find the answers and grow with us.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}

            {job?.position === "디자인" && job?.sort === "Graphic" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    그래픽 콘텐츠 디자이너는
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    mondayoff를 세상에 보여주기 위한 첫 모습을 디자인합니다.
                    작게는 소셜 네트워크 속 하나의 게시글부터 시작해 우리의
                    홈페이지와 내/외부적으로 진행되는 이벤트의 비주얼 요소를
                    작업하기도 하고 더 나아가 브랜드 아이덴티티를 만들 수도
                    있습니다. 단순한 콘텐츠 제작을 넘어서 유저들에게 mondayoff를
                    더 재미있고 인상적으로 알릴 수 있는 방향을 탐구합니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
            {job?.position === "사업/마케팅" &&
              job?.sort === "Marketing" &&
              job?.lo === "en" && (
                <>
                  <div>
                    <p
                      className={classNames(styles.cotext_title, {
                        "title-kr-XL": true,
                      })}
                    >
                      mondayoff, Hypercasual Lead in East Asia{" "}
                    </p>
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      mondayoff is East Asia’s leading studio and publisher in
                      the field of the mobile game genre Hyper Casual. With tons
                      of experience developing in-house games and publishing
                      games with our partners from around the world, we strive
                      to become one of the top global mobile game publishers.
                      Since our foundation in 2018, we’ve grown to become a team
                      of over 25 developers, designers and publishing managers.
                      We are looking for new talent to bring out the most
                      creative games in the market that are fun and keep players
                      engaged for a long time.
                    </p>
                  </div>
                  <div>
                    <p
                      className={classNames(styles.cotext_title, {
                        "title-kr-XL": true,
                      })}
                    >
                      What are hypercasual games?
                    </p>
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      Hypercasual games are enjoyed by players worldwide, no
                      matter their language, cultural background, age or gender.
                      Simple rules and design that can be understood within 3
                      seconds make hypercasual games different from other mobile
                      games on the market.
                    </p>
                    <br />
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      Korea’s leading mobile game genres tend to be RPG and
                      defense, differing strongly from the international market.
                      Over 70% of the US iOS Game Top 50 are hypercasual games
                      and numbers are rising steadily.
                    </p>
                    <br />
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      Studios developing hypercasual games have to go beyond
                      simple R{"&"}D. “What effect will bring the most
                      satisfaction to the player at this instance?” “Is the UX
                      too complicated for the players?” “Why do players quit
                      playing at certain stages of the game?” are questions we
                      constantly have to answer in order to reach a wide
                      audience.
                    </p>
                    <br />
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      At MondayOFF, we are looking for creative people that will
                      try to find the answers and grow with us.
                    </p>
                  </div>
                  <div>
                    <p
                      className={classNames(styles.cotext_title, {
                        "title-kr-XL": true,
                      })}
                    >
                      Market Growth Team of MondayOFF
                    </p>
                    <p
                      className={classNames({
                        "body-kr-L": true,
                      })}
                    >
                      As a Monetization Manager, you will be part of the Market
                      Growth Team of MondayOFF. MondayOFF has top class
                      experiences especially in User Acquisition and
                      Monetization. Each member will deal with at least $10M of
                      revenue or UA budget per year. You also are able to access
                      substantial information about Monetization {"&"} UA
                      strategy for being a global top publisher. MondayOFF wants
                      only a few highly talented colleagues to communicate with
                      international teams.
                    </p>
                  </div>
                </>
              )}
            {job?.position === "사업/마케팅" && job?.sort === "Creative" ? (
              <>
                <div>
                  <p
                    className={classNames(styles.cotext_title, {
                      "title-kr-XL": true,
                    })}
                  >
                    mondayoff Creative팀은{" "}
                  </p>
                  <p
                    className={classNames({
                      "body-kr-L": true,
                    })}
                  >
                    먼데이오프에서 출시한 하이퍼 캐주얼 게임들의 날개를 달아주는
                    팀입니다. 출시하는 게임들의 홍보 영상을 제작하고, 유저의
                    반응을 분석하여, 보다 좋은 결과를 도출할 수 있도록 항상
                    고민합니다. 영상편집 직무에 국한되기보단, 데이터를 분석하고
                    어떤 영상을 제작할지 창의적으로 생각하여 업무를 진행합니다.
                  </p>
                </div>
              </>
            ) : (
              ""
            )}
          </section>
          <section className={styles.bottom_context}>
            <div
              className={classNames(
                !isDarkMode ? styles.applyDetail : styles.dark_applyDetail
              )}
            >
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Description" : "담당업무"}
                </p>

                <section
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                >
                  {job?.RS.map((list: any) => (
                    <section className={styles.contents_box}>
                      <p className={classNames({ "title-kr-L": true })}>
                        {list?.title}
                      </p>
                      {list.contents.map((item: string) => (
                        <span className={styles.contents_text}>
                          <p>•</p>
                          <p className={classNames({ "body-kr-L": true })}>
                            {item}
                          </p>
                        </span>
                      ))}
                    </section>
                  ))}
                </section>
              </section>

              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Qualifications" : "지원자격"}
                </p>
                <section className={classNames(styles.contents_box)}>
                  {job?.lo === "en" && (
                    <>
                      <p
                        style={{
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                      >
                        • Visa holders: E-7, F-2, F-4, F-5, F-6, D-10, D-2
                        (possible to sponsor by company)
                      </p>
                      <p
                        style={{
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                      >
                        • Full - Time worker
                      </p>
                      <p
                        style={{
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                      >
                        • Must Reside in Korea
                      </p>
                      {job?.MQ?.map((d: any, i: number) => (
                        <p key={i}>• {d}</p>
                      ))}
                    </>
                  )}
                  {job?.MQ?.map((d, i) => (
                    <div key={i}>• {d}</div>
                  ))}
                </section>
              </section>
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Preferences" : "우대조건"}
                </p>
                <section className={classNames(styles.contents_box)}>
                  {job?.PQ?.map((d: any, i: number) => (
                    <p key={i}>• {d}</p>
                  ))}
                </section>
              </section>
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Basic Requirement" : "공통 지원자격"}
                </p>
                <section className={classNames(styles.contents_box)}>
                  <p>
                    •{" "}
                    {job?.lo === "en"
                      ? "Must be able to travel abroad"
                      : "해외 여행에 결격 사유가 없으신 분"}
                  </p>
                </section>
              </section>
              <section>
                <div
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
                  )}
                >
                  <p className={classNames({ "title-kr-XL": true })}>
                    {job?.lo === "en"
                      ? "Required Documents"
                      : "제출 서류 및 방법"}{" "}
                  </p>
                  <p className={classNames({ "label-kr-M": true })}>
                    *{" "}
                    {job?.lo === "en"
                      ? "All documents should be uploaded as a PDF file."
                      : "제출 서류 모두 PDF파일로 제출"}
                  </p>
                </div>
                <section className={classNames(styles.contents_box)}>
                  {job?.DC?.map((d: any, i: number) => (
                    <p
                      className={classNames(
                        !isDarkMode
                          ? styles.detailContext
                          : styles.dark_detailContext
                      )}
                      key={i}
                    >
                      • {d}
                    </p>
                  ))}
                </section>
              </section>
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Application Process" : "채용절차"}
                </p>
                {job?.OHP?.map((d: any, i: number) => (
                  <section className={classNames(styles.contents_box)} key={i}>
                    <p> • {d}</p>
                    <p>
                      {job?.lo === "en" &&
                        "* Duration may be subject to change"}
                    </p>
                  </section>
                ))}
              </section>
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Working Conditions" : "근무 조건"}
                </p>
                <section className={classNames(styles.contents_box)}>
                  <p>• {job.form}</p>

                  <p>
                    •{" "}
                    {job?.lo === "en"
                      ? "Work Hours : 09:00 - 17:00, Mon-Fri (Work Hours Flexible)"
                      : "근무 시간 : 주 5일 (월요일 ~ 금요일 근무, 일일 근로시간 7시간)"}
                  </p>
                  {!job?.lo && <p>• 급여 조건 : 회사 내규에 따름</p>}

                  <p>
                    •{" "}
                    {job?.lo === "en"
                      ? "Location : Seoul, Gangnam-gu. 3 minute walk from Samsung Jungang Station (Line 9 Line)"
                      : "근무지 : 서울 강남구 9호선 삼성중앙역 도보 3분 이내"}
                  </p>
                </section>
              </section>
              <section>
                <p
                  className={classNames(
                    !isDarkMode ? styles.detailTitle : styles.dark_detailTitle,
                    { "title-kr-XL": true }
                  )}
                >
                  {job?.lo === "en" ? "Additional Information" : "기타 사항"}
                </p>

                <p
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                >
                  •{" "}
                  {job?.lo === "en"
                    ? "False information on job applications may lead to the withdrawal of the job offer even after successful admission"
                    : "  입사 지원 서류에 허위사실이 발견될 경우, 채용확정 이후라도 입사가 취소될 수 있습니다."}
                </p>
                <p
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                >
                  •{" "}
                  {job?.lo === "en"
                    ? "In accordance with Article 11, Paragraph 6 of the Fair Hiring Procedure Act, applicants who are not selected as final candidates may request the return of their submitted application documents."
                    : "  채용절차의 공정화에 관한 법률 제 11조 6항에 따라, 최종합격자를 제외한 구직자는 제출하신 채용서류를 반환받을 수 있습니다."}
                </p>
              </section>
            </div>
            <Link
              to="/position"
              className={classNames(
                !isDarkMode ? styles.backBtn : styles.dark_backBtn
              )}
            >
              <LeftIcon />
              <p
                className={classNames({
                  "label-kr-L": true,
                })}
              >
                {job?.lo === "en" ? "Back" : "목록으로"}
              </p>
            </Link>
          </section>
        </div>
        <div
          className={classNames(
            !isDarkMode ? styles.apply_container : styles.dark_apply_container
          )}
        >
          <section className={styles.detail_info}>
            <div className={styles.detail_info_item}>
              <p className={classNames({ "title-kr-M": true })}>직군</p>
              <p className={classNames({ "body-kr-M": true })}>{job.duty}</p>
            </div>
            <div className={styles.detail_info_item}>
              <p className={classNames({ "title-kr-M": true })}>경력사항</p>
              <p className={classNames({ "body-kr-M": true })}>
                {job.type.split("•")[1]}
              </p>
            </div>
            <div className={styles.detail_info_item}>
              <p className={classNames({ "title-kr-M": true })}>고용형태</p>
              <p className={classNames({ "body-kr-M": true })}>
                {job.type.split("•")[0]}
              </p>
            </div>
            <div className={styles.detail_info_item}>
              <p className={classNames({ "title-kr-M": true })}>마감기한</p>
              <p className={classNames({ "body-kr-M": true })}>-</p>
            </div>
          </section>
          <Link
            to="/position/apply"
            state={{ data: job }}
            className={classNames(
              { "red-medium-button": true },
              styles.applyBtn
            )}
          >
            <p className={classNames({ "label-kr-M": true })}>
              {job?.lo === "en" ? "Apply now" : "지원하기"}
            </p>
          </Link>
        </div>
        <section className={styles.apply_btn_768_container}>
          <Link
            to="/position/apply"
            state={{ data: job }}
            className={classNames(
              { "red-medium-button": true },
              styles.applyBtn_768
            )}
          >
            <p className={classNames({ "label-kr-M": true })}>
              {job?.lo === "en" ? "Apply now" : "지원하기"}
            </p>
          </Link>
        </section>
      </section>
    </div>
  );
}
